import { SETTING_ATTRIBUTE_IDS } from './settings.constants';

export default function GeneralSettingFactory(UtilService) {
  const defaultAttrs = {
      id: null,
      code: null,
      name: null,
      value: null,
      minValue: null,
      sortOrder: null,
      unit: null,
      settingAttributeId: null,
      disabled: null,
    },
    GeneralSetting = function(data) {
      angular.merge(this, defaultAttrs, data);
    };

  GeneralSetting.UNITS = {
    AMOUNT: 'AMOUNT',
    MINUTE: 'MINUTE',
    DAY: 'DAY',
    HOUR: 'HOUR',
    N_A: 'N_A',
  };
  GeneralSetting.DISPLAY_TYPES = [
    {
      name: 'Disabled',
      value: 0,
    },
    {
      name: 'By shift',
      value: 1,
    },
    {
      name: 'Without shift',
      value: 2,
    },
  ];

  GeneralSetting.CODES = {
    RETURN_TO_CURRENT_DATE: 'RETURN_TO_CURRENT_DATE',
    DISPLAY_CUSTOMER_PROFILE: 'DISPLAY_CUSTOMER_PROFILE',
    ONLINE_RESERVATION_DAYTIME: 'ONLINE_RESERVATION_DAYTIME',
    SCREENSAVER: 'SCREENSAVER',
    DEFAULT_PEOPLE_COUNT: 'DEFAULT_PEOPLE_COUNT',
    OVERBOOKING: 'OVERBOOKING',
    OVERBOOKING_AREA: 'OVERBOOKING_AREA',
    ONLINE_RESERVATION_INTERVAL: 'ONLINE_RESERVATION_INTERVAL',
    ONLINE_RESERVATION_INTERVAL_EXTERNAL_PARTNER: 'ONLINE_RESERVATION_INTERVAL_EXTERNAL_PARTNER',
    OFFLINE_RESERVATION_INTERVAL: 'OFFLINE_RESERVATION_INTERVAL',
    AUTOMATIC_CHECKOUT_TIME: 'AUTOMATIC_CHECKOUT_TIME',
    RECOMMEND_TABLES: 'RECOMMEND_TABLES',
    AVERAGE_SPENT_PER_PERSON: 'AVERAGE_SPENT_PER_PERSON',
    DEFAULT_VIEW: 'DEFAULT_VIEW',
    FULL_SYNC_INTERVAL: 'FULL_SYNC_INTERVAL',
    MANDATORY_STAFF_SELECTION: 'MANDATORY_STAFF_SELECTION',
    TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
    AIRREGI_INTEGRATION: 'AIRREGI_INTEGRATION',
    AIRREGI_INTEGRATION_TOKEN: 'AIRREGI_INTEGRATION_TOKEN',
    MAX_LEADING_TIME: 'MAX_LEADING_TIME',
    MIN_LEADING_TIME: 'MIN_LEADING_TIME',
    MAX_ONLINE_CAPACITY: 'MAX_ONLINE_CAPACITY',
    SHOW_START_TIMES: 'SHOW_START_TIMES',
    DINING_PACKAGE_ENABLED: 'DINING_PACKAGE_ENABLED',
    DISABLE_GOOGLE_BOOKING_LINK: 'DISABLE_GOOGLE_BOOKING_LINK',
    DISABLE_GOOGLE_BOOKING_INTEGRATION: 'DISABLE_GOOGLE_BOOKING_INTEGRATION',
    SPECIAL_COMMUNICATION_BOX: 'SPECIAL_COMMUNICATION_BOX',
    SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL: 'SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL',
    SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL_MESSAGE: 'SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL_MESSAGE',
    SHOW_POST_CODE_ON_WIDGET: 'SHOW_POST_CODE_ON_WIDGET',
    CARD_VAULT_STATUS: 'CARD_VAULT_STATUS',
    PRE_ORDER_MENU_ENABLED: 'PRE_ORDER_MENU_ENABLED',
    PRE_ORDER_GUESTS_MIN_CHECK: 'PRE_ORDER_GUESTS_MIN_CHECK',
  };

  GeneralSetting.SETTING_ATTRIBUTE_IDS = {
    OVERBOOKING_AREA: 1043,
    AIRREGI_INTEGRATION: 1068,
    SPECIAL_COMMUNICATION_BOX: 1072,
    SHOW_POST_CODE_ON_WIDGET: 1088,
    PRE_ORDER_MENU_ENABLED: 1081,
  };

  const airRegiDefaultToken = angular.copy(defaultAttrs);
  airRegiDefaultToken.code = GeneralSetting.CODES.AIRREGI_INTEGRATION_TOKEN;
  airRegiDefaultToken.settingAttributeId = GeneralSetting.SETTING_ATTRIBUTE_IDS.AIRREGI_INTEGRATION;
  GeneralSetting.airRegiDefaultToken = airRegiDefaultToken;

  const menuMngtMinGuest = angular.copy(defaultAttrs);
  menuMngtMinGuest.code = GeneralSetting.CODES.PRE_ORDER_GUESTS_MIN_CHECK;
  menuMngtMinGuest.settingAttributeId = GeneralSetting.SETTING_ATTRIBUTE_IDS.PRE_ORDER_MENU_ENABLED;
  GeneralSetting.menuMngtMinGuest = menuMngtMinGuest;

  const specialCommunicationBoxDefault = angular.copy(defaultAttrs);
  specialCommunicationBoxDefault.code = GeneralSetting.CODES.SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL_MESSAGE;
  specialCommunicationBoxDefault.settingAttributeId = GeneralSetting.SETTING_ATTRIBUTE_IDS.SPECIAL_COMMUNICATION_BOX;
  GeneralSetting.specialCommunicationBoxDefault = specialCommunicationBoxDefault;

  GeneralSetting.NAMES = {
    OVERBOOKING_AREA: 'Overbooking area',
  };

  GeneralSetting.possibleValuesMappings = {};
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.SCREENSAVER] = [
    1,
    2,
    3,
    4,
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    120,
    180,
    240,
    300,
    360,
    420,
    480,
    540,
    600,
    660,
    720,
  ];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.MAX_LEADING_TIME] = [
    7,
    14,
    21,
    30,
    45,
    60,
    75,
    90,
    105,
    120,
    135,
    150,
    165,
    180,
    195,
    210,
    225,
    240,
    255,
    270,
    285,
    300,
    315,
    330,
    345,
    360,
  ];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.ONLINE_RESERVATION_INTERVAL] = [15, 30, 60];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.ONLINE_RESERVATION_INTERVAL_EXTERNAL_PARTNER] = [10, 15, 20, 30, 60];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.OFFLINE_RESERVATION_INTERVAL] = [15, 30, 60];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.DEFAULT_PEOPLE_COUNT] = [1, 2, 3, 4];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.AUTOMATIC_CHECKOUT_TIME] = [-1, 0, 15, 30, 60, 90, 120];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.DEFAULT_VIEW] = ['table plan', 'time matrix'];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.ONLINE_RESERVATION_DAYTIME] = [0, 1, 2, 3];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.FULL_SYNC_INTERVAL] = [1, 2, 5, 10, 15, 30];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.MANDATORY_STAFF_SELECTION] = [0, 1, 2, 3];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.CARD_VAULT_STATUS] = [0, 1, 2, 3];
  GeneralSetting.possibleValuesMappings[GeneralSetting.CODES.MAX_ONLINE_CAPACITY] = UtilService.generateNumericRange(0, 999);

  GeneralSetting.build = function(data) {
    return new GeneralSetting(data);
  };

  GeneralSetting.getByCode = function(code, collection) {
    const settings = [];
    for (let i = collection.length - 1; i >= 0; i--) {
      if (collection[i].code === code) {
        settings.push(collection[i]);
      }
    }

    return settings;
  };

  GeneralSetting.spliceByCode = function(code, collection) {
    let settings = [];
    for (let i = collection.length - 1; i >= 0; i--) {
      if (collection[i].code === code) {
        settings = settings.concat(collection.splice(i, 1));
      }
    }

    return settings;
  };

  GeneralSetting.DEFAULT_SETTING_VALUES = {
    '1088': {
      code: 'SHOW_POST_CODE_ON_WIDGET',
      settingAttributeId: 1088,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
    },
    '1069': {
      code: 'SEPARATE_CHECKBOX_WIDGET_MERCHANT_NEWSLETTER',
      settingAttributeId: 1069,
      unit: GeneralSetting.UNITS.N_A,
      value: '1',
    },
    [SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_ENABLED]: {
      code: 'DINING_PACKAGE_ENABLED',
      settingAttributeId: SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_ENABLED,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
      sortOrder: 45,
    },
    [SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_REQUIRED]: {
      code: 'DINING_PACKAGE_REQUIRED',
      settingAttributeId: SETTING_ATTRIBUTE_IDS.DINING_PACKAGE_REQUIRED,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
      sortOrder: 46,
    },
    [SETTING_ATTRIBUTE_IDS.LOGIN_TO_HOST_ENABLED]: {
      code: 'LOGIN_TO_HOST_ENABLED',
      settingAttributeId: SETTING_ATTRIBUTE_IDS.LOGIN_TO_HOST_ENABLED,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
      sortOrder: 47,
    },
    '1070': {
      code: 'DISABLE_GOOGLE_BOOKING_LINK',
      settingAttributeId: 1070,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
    },
    '1071': {
      code: 'SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL',
      settingAttributeId: 1071,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
    },
    '1072': {
      code: 'SPECIAL_COMMUNICATION_BOX_WIDGET_PORTAL_MESSAGE',
      settingAttributeId: 1072,
      unit: GeneralSetting.UNITS.N_A,
      value: '',
    },
    '1083': {
      code: 'IOVOX_NUMBER',
      settingAttributeId: 1083,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
    },
    '1074': {
      code: 'CREDIT_CARD_VAULT_STATUS',
      settingAttributeId: 1074,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
    },
    '1080': {
      code: 'PRE_ORDER_MENU_ENABLED',
      settingAttributeId: 1080,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
    },
    '1081': {
      code: 'PRE_ORDER_GUESTS_MIN_CHECK',
      settingAttributeId: 1081,
      unit: GeneralSetting.UNITS.N_A,
      value: '20',
    },
    '1067': {
      code: 'AIRREGI_INTEGRATION',
      settingAttributeId: 1067,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
    },
    '1068': {
      code: 'AIRREGI_INTEGRATION_TOKEN',
      settingAttributeId: 1068,
      unit: GeneralSetting.UNITS.N_A,
      value: '',
    },
    '1085': {
      code: 'DISABLE_GOOGLE_BOOKING_INTEGRATION',
      settingAttributeId: 1085,
      unit: GeneralSetting.UNITS.N_A,
      value: '0',
      sortOrder: 50,
    },
  };

  return GeneralSetting;
}



// WEBPACK FOOTER //
// ./src/app/merchants/settings/generalSettings.model.js